import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetListHistory = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_HISTORY_LIST
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetListHistoryAction({
                    data: data.data,
                    countPage: data.countPage
                }));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetListHistory as SetGetListHistory
}